import type { PluginObject, VNode } from 'vue'
import { ModalPlugin } from 'bootstrap-vue'

import ConfirmMixin from './mixins/confirm.mixin'

import DefaultConfirm from './components/DefaultConfirm.vue'

function confirm(
  this: Vue,
  message: string,
  options: {
    title?: string
    append?: VNode[]
  } = {}
) {
  const div = document.createElement('div')
  document.body.append(div)
  const instance = new DefaultConfirm({
    propsData: {
      text: message,
      title: options.title,
    },
  }) as InstanceType<typeof ConfirmMixin>
  if (options.append !== undefined) {
    instance.$slots.append = options.append
  }
  instance.$mount(div)
  return instance.confirm().finally(() => {
    instance.$destroy()
  })
}

export type Confirm = typeof confirm

const ConfirmPlugin: PluginObject<never> = {
  install(Vue) {
    const ConfirmMixin = Vue.extend({
      created() {
        this.$confirm = confirm
      },
    })

    Vue.use(ModalPlugin)
    Vue.mixin(ConfirmMixin)
  },
}

export default ConfirmPlugin
